import script from "./violation-information.vue?vue&type=script&setup=true&lang=js"
export * from "./violation-information.vue?vue&type=script&setup=true&lang=js"

import "./violation-information.vue?vue&type=style&index=0&id=049e0e85&scoped=true&lang=css"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049e0e85"]])

export default __exports__